module.exports = __webpack_public_path__ + "img/dialogSuccess.03160efa.png";